import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class LinkShareAccessNudgeModalService {
  constructor(private httpClient: HttpClient) {}

  request(eventId: number): Observable<void> {
    return this.httpClient.post<void>(
      `/index.php/link-share/request-access?eventId=${eventId}`,
      null
    );
  }
}
